import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from '../Carousel.css';
import { ICarouselProps, TMediaItemSchema } from '../interfaces';
import { NoImage } from '../part/NoImage';
import { Preloader } from '../part/Preloader';

export interface ILazyLoadCarouselState {
  module: React.ComponentClass<ICarouselProps> | null;
  show: boolean;
  sliderInited: boolean;
}

export interface ILazyLoadCarouselProps {
  media: Array<TMediaItemSchema> | null;
}

export class LazyLoadCarousel extends React.Component<ILazyLoadCarouselProps, ILazyLoadCarouselState> {
  public state = {
    module: null,
    show: true,
    sliderInited: false,
  };

  public resolveCarousel = () => {
    return import('../Carousel');
  };

  public async componentDidMount() {
    const { Carousel: module } = await this.resolveCarousel();
    this.setState({ module });
  }

  public render() {
    const { module, show, sliderInited } = this.state;
    const { media: mediaData } = this.props;
    const carousel: React.ComponentClass<ICarouselProps> | null = module;

    if (!mediaData) {
      return (
        <div className={styles['carousel']}>
          <NoImage />
        </div>
      );
    }
    if (!carousel || !show) {
      return <Preloader media={mediaData} />;
    }

    return (
      <>
        <div {...mergeStyles(!sliderInited && styles['hidden'])}>
          {React.createElement(carousel, { media: mediaData, onSliderInit: this.onSliderInit })}
        </div>
        {!sliderInited && <Preloader media={mediaData} />}
      </>
    );
  }

  private onSliderInit = () => {
    this.setState({
      sliderInited: true,
    });
  };
}
